module.exports = __webpack_public_path__ + "fonts/green-left-bottom.svg";